// Optional selects over id/label references (a linked CLIN, a linked
// deliverable): Radix Select can't hold an empty-string value, so a sentinel
// "none" item stands in for "not linked / none" and maps back to '' on save.
export const SELECT_NONE = '__none__';
/** Prepend a clearable "— None —" item to an options list. */ export function withNoneOption(options) {
    return [
        {
            value: SELECT_NONE,
            label: '— None —'
        },
        ...options
    ];
}
/** Stored value → select value: empty becomes the none sentinel. */ export const toSelectValue = (stored)=>stored || SELECT_NONE;
/** Select value → stored value: the none sentinel becomes empty. */ export const fromSelectValue = (value)=>value === SELECT_NONE ? '' : value;
const UNAVAILABLE = 'Linked (unavailable)';
/**
 * Append the stored id as its own option when it isn't already in the list, so
 * an editing row whose linked target is superseded (a non-current CLIN) or paged
 * out stays visible and selected instead of silently blanking. Mirrors the
 * "(legacy)" fallback escalation and impact use for out-of-set values.
 */ export function withStoredFallback(options, storedId) {
    if (storedId && storedId !== SELECT_NONE && !options.some((o)=>o.value === storedId)) {
        return [
            ...options,
            {
                value: storedId,
                label: UNAVAILABLE
            }
        ];
    }
    return [
        ...options
    ];
}
/** Resolve a stored id to its option label for read-only display; empty → em dash. */ export function labelForOption(id, options) {
    if (!id) return '—';
    return options.find((o)=>o.value === id)?.label ?? UNAVAILABLE;
}
